import { errorRangoFechasFiltro } from "@/util/validarRangoFechasFiltro";
import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";
import { franquiciaService } from "./franquicia.service";

function convertirLocal(idEnvio) {
  const axios = createAxios();
  let body = { courier: "OXPERTA" };
  const franquicia = franquiciaService.getLocalFranquicia();
  const urlPath = `/franquicia/${franquicia._id}/envio/${idEnvio}/courier`;
  return axios.put(urlPath, body);
}
function logisticaInversa(body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  const urlPath = `/franquicia/${franquicia._id}/envio/${body._id}/invertir`;
  return axios.post(urlPath, body);
}

function sendEnvio(body) {
  const axios = createAxios();
  const urlPath = "/envio";
  return axios.post(urlPath, body);
}

function newEventoEnvio(envio_id, body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `/franquicia/${franquicia._id}/envio/${envio_id}/estados`;
  return axios.post(urlPath, body);
}

function getFiltersEnvios(filters) {
  let urlPath = "";

  if (filters && filters.servicios) {
    urlPath += `&servicios=${filters.servicios.join()}`;
  }

  if (filters && filters.estados && filters.estados.length > 0) {
    urlPath += `&estados=${filters.estados.join()}`;
  }

  if (filters && filters.sort) {
    urlPath += `&sort=${filters.sort.prop}&order=${filters.sort.order}`;
  }

  if (filters && filters.localizador) {
    urlPath += `&localizador=${filters.localizador}`;
  }

  if (filters && filters.identificadores) {
    urlPath += `&identificadores=${filters.identificadores}`;
  }

  if (filters && filters.numeroRecogida) {
    urlPath += `&numeroRecogida=${filters.numeroRecogida}`;
  }
  if (filters && filters.numeroEntrega) {
    urlPath += `&numeroEntrega=${filters.numeroEntrega}`;
  }

  if (filters && filters.gestor) {
    urlPath += `&gestorResponsable=${filters.gestor}`;
  }

  if (filters && filters.localizadorBulto) {
    urlPath += `&localizadorBulto=${filters.localizadorBulto}`;
  }

  if (filters && filters.tipo) {
    urlPath += `&tipo=${filters.tipo}`;
  }

  if (filters && filters.referencia) {
    urlPath += `&referencia=${filters.referencia}`;
  }

  if (filters && filters._id) {
    urlPath += `&_id=${filters._id}`;
  }

  if (filters && filters.destinatario) {
    urlPath += `&destinatario=${filters.destinatario}`;
  }
  if (filters && filters.cp_destino) {
    urlPath += `&cp_destino=${filters.cp_destino}`;
  }
  if (filters && filters.remitente) {
    urlPath += `&remitente=${filters.remitente}`;
  }
  if (filters && filters.cp_origen) {
    urlPath += `&cp_origen=${filters.cp_origen}`;
  }
  if (filters && filters.idCliente) {
    urlPath += `&idCliente=${filters.idCliente}`;
  }

  if (filters && filters.repartidor) {
    urlPath += `&repartidor=${filters.repartidor}`;
  }

  if (filters && filters.tipo_devolucion) {
    urlPath += `&tipo_devolucion=${filters.tipo_devolucion}`;
  }

  if (filters && filters.courierMillaIntermedia) {
    urlPath += `&courierMillaIntermedia=${filters.courierMillaIntermedia}`;
  }

  if (filters && filters.date) {
    urlPath += `&dateStart=${filters.date[0]}`;
    urlPath += `&dateEnd=${filters.date[1]}`;
  }

  if (filters && typeof filters.anomalia == "boolean" && filters.anomalia) {
    urlPath += "&anomalia=" + filters.anomalia;
  }

  if (filters && typeof filters.reembolso == "boolean" && filters.reembolso) {
    urlPath += "&reembolso=" + filters.reembolso;
  }

  if (filters && filters.recogida) {
    urlPath += `&recogida=${filters.recogida}`;
  }

  if (filters && filters.entrega) {
    urlPath += `&entrega=${filters.entrega}`;
  }

  if (filters && filters.queryBase) {
    urlPath += `&queryBase=${filters.queryBase}`;
  }


  if (
    filters &&
    typeof filters.origenEnvioProgramado == "boolean" &&
    filters.origenEnvioProgramado
  ) {
    urlPath += "&app=PLANTILLA";
  }

  if (filters && typeof filters.origenRma == "boolean" && filters.origenRma) {
    urlPath += "&app=RMA";
  }

  if (
    filters &&
    typeof filters.entregaSabado == "boolean" &&
    filters.entregaSabado
  ) {
    urlPath += `&entregaSabado=${filters.entregaSabado}`;
  }

  if (filters && filters.alias) {
    urlPath += `&alias=${filters.alias}`;
  }

  if (filters && filters.idFiscal) {
    urlPath += `&idFiscal=${filters.idFiscal}`;
  }

  if (filters && filters.codigo) {
    urlPath += `&codigo=${filters.codigo}`;
  }


  return urlPath;
}

function getAllEnvios(pagination, filters) {
  const error = errorRangoFechasFiltro(filters, "date");
  if (error) return Promise.reject(error);
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/envio`;

  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=10";
  }

  urlPath += getFiltersEnvios(filters);

  return axios.get(urlPath);
}

function getEnvio(envioId) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/envio/${envioId}`;
  return axios.get(urlPath);
}

function getValoracionSimular(body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/valoracion_simular/`;
  return axios.post(urlPath, body);
}

function getValoracionesCouriers(body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/valoracion_comparar`;
  return axios.post(urlPath, body);
}

function getDirHabituales(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/cliente/${body.clientId}/direcciones`;
  if (body.page != null) {
    urlPath += `?page=${body.page}&limit=${body.limit}&`;
  } else {
    urlPath += "?";
  }
  if (body.tipo) {
    urlPath += `tipo=${body.tipo}&`;
  }

  if (body.order) {
    urlPath += `order=${body.order}&`;
  }

  if (body.sort) {
    urlPath += `sort=${body.sort}&`;
  }

  if (body.normalizada) {
    urlPath += `normalizada=${body.normalizada}`;
  }
  return axios.get(urlPath);
}

function modificarEstado(envioId) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/envio/${envioId}/estados`;
  let body = { codigo: "19" };
  return axios.post(urlPath, body);
}

function envioEtiquetaFranquicia(body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  const urlPath = `franquicia/${franquicia._id}/envio/etiqueta`;
  return axios.post(urlPath, body, {
    responseType: "blob",
  });
}

function envioEtiquetaMail(body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  const urlPath = `franquicia/${franquicia._id}/envio/etiqueta/mail`;
  return axios.post(urlPath, body);
}

function getEstadosEnvio(envioId) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/envio/${envioId}/estados`;
  return axios.get(urlPath);
}

function getEstadosEnvioCourier(localizador, courier) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/envio/${localizador}/courier/${courier}/estados`;
  return axios.get(urlPath);
}

function getEnviosAsExcel(filters) {
  const error = errorRangoFechasFiltro(filters, "date");
  if (error) return Promise.reject(error);
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `/franquicia/${franquicia._id}/envio/excel?limit=2000`;

  urlPath += getFiltersEnvios(filters);

  return axios.get(urlPath, {
    responseType: "blob",
  });
}


function getJustificanteServicio(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/envio/${request}/justificante-servicio`;
  return axios
    .get(urlPath, {
      responseType: "blob",
    })
    .catch(async (error) => {
      const data = await error.text();
      throw JSON.parse(data);
    });
}

function getScanCTT(idEnvio) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquicia/${user.extraData.franquiciaId}/envio/${idEnvio}/scan-ctt`;
  return axios
    .get(urlPath, { responseType: "blob" })
    .then((response) => {
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition;
      return Promise.resolve({ blob: response.data, fileName: fileName });
    })
    .catch(async (error) => {
      throw JSON.parse(await error.text());
    });
}


function sendEnvioProgramado(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `/franquicia/${user.extraData.franquiciaId}/cliente/${request.envio.cliente}/plantilla`;
  return axios.post(urlPath, request);
}

function editarBultos(idEnvio, body) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  let urlPath = `franquicia/${franquicia._id}/local/envio/${idEnvio}`;
  return axios.put(urlPath, body);
}

function getManifiesto({ cliente, tipo, fecha, courier }) {
  const axios = createAxios();
  const franquicia = franquiciaService.getLocalFranquicia();
  return axios.get(`/franquicia/${franquicia._id}/manifiesto`, {
    params: { cliente, tipo, fecha, courier },
    responseType: "blob",
  }).catch((error) => {
    if (!(error instanceof Blob)) return Promise.reject(error);
    return error.text().then((text) => {
      try {
        return Promise.reject(JSON.parse(text));
      } catch {
        return Promise.reject(new Error("No se pudo generar el manifiesto"));
      }
    });
  });
}

export const envioService = {
  getManifiesto,
  getAllEnvios,
  sendEnvio,
  getDirHabituales,
  getEnvio,
  modificarEstado,
  envioEtiquetaFranquicia,
  getEnviosAsExcel,
  getEstadosEnvio,
  newEventoEnvio,
  sendEnvioProgramado,
  logisticaInversa,
  getValoracionSimular,
  getJustificanteServicio,
  convertirLocal,
  envioEtiquetaMail,
  editarBultos,
  getValoracionesCouriers,
  getScanCTT,
  getEstadosEnvioCourier,
};
